import styled from "@emotion/styled";
import { Loader } from "../loader";

interface Props {
  loading: boolean;
}

export function LoadingOverlay(props: Props) {
  return (
    <Overlay shown={props.loading}>
      <Loader />
    </Overlay>
  );
}

const Overlay = styled.div<{ shown: boolean }>`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.8);
  opacity: ${(props) => (props.shown ? 1 : 0)};
  pointer-events: ${(props) => (props.shown ? "auto" : "none")};
  transition: opacity 100ms;
`;
